<template>
  <div id="references">
    <InnerContent>
      <ContentHeader title="References" />
      <ol>
        <li>
          Dendrou CA, Fugger L, Friese MA. Immunopathology of multiple
          sclerosis. <cite>Nat Rev Immunol.</cite> 2015;15(9):545-558.
          doi:10.1038/nri3871
        </li>
        <li>
          Li R, Patterson KR, Bar-Or A. Reassessing B cell contributions in
          multiple sclerosis. <cite>Nat Immunol.</cite> 2018;19(7):696-707.
          doi:10.1038/s41590-018-0135-x
        </li>
        <li>
          Hoffmann F, Meinl E. B cells in multiple sclerosis: good or bad guys?
          <cite>Eur J Immunol.</cite> 2014;44(5):1247-1250.
          doi:10.1002/eji.201470045
        </li>
        <li>
          Gross CC, Schulte-Mecklenbeck A, Wiendl H, et al. Regulatory functions
          of natural killer cells in multiple sclerosis.
          <cite>Front lmmunol.</cite> 2016;7(DEC). doi:10.3389/fimmu.2016.00606
        </li>
        <li>
          Redman JM, Hill EM, AlDeghaither D, Weiner LM. Mechanisms of action of
          therapeutic antibodies for cancer.
          <cite>Mol Immunol.</cite> 2015;67(2):28-45.
          doi:10.1016/j.molimm.2015.04.002
        </li>
        <li>
          Boross P, Leusen JH. Mechanisms of action of CD20 antibodies.
          <cite>Am J Cancer Res.</cite> 2012;2(6):676-690.
        </li>
        <li>
          Kister I, Bacon TE, Chamot E, et al. Natural history of multiple
          sclerosis symptoms. <cite>Int J MS Care.</cite> 2013;15(3):146-158.
          doi:10.7224/1537-2073.2012-053
        </li>
        <li>
          Betts CD, D’Mellow MT, Fowler CJ. Urinary symptoms and the
          neurological features of bladder dysfunction in multiple sclerosis.
          <cite>J Neurol Neurosurg Psychiatry.</cite> 1993;56(3):245-250.
          doi:10.1136/jnnp.56.3.245
        </li>
        <li>
          Claes N, Fraussen J, Stinissen P, Hupperts R, Somers V. B cells are
          multifunctional players in multiple sclerosis pathogenesis: Insights
          from therapeutic interventions.<cite> Front Immunol.</cite>
          2015;6(DEC). doi:10.3389/fimmu.2015.00642
        </li>
        <li>
          Lehmann Horn K, Kronsbein HC, Weber MS. Targeting B cells in the
          treatment of multiple sclerosis: Recent advances and remaining
          challenges.<cite>Ther Adv Neurol Disord.</cite> 2013;6(3):161-173.
          doi:10.1177/1756285612474333
        </li>
        <li>
          Häusser-Kinzel S, Weber MS. The role of B cells and antibodies in
          multiple sclerosis, neuromyelitis optica, and related disorders.
          <cite>Front Immunol.</cite> 2019;10(201). doi:10.3389/fimmu.2019.00201
        </li>
        <li>
          Patejdl R, Zettl UK. Spasticity in multiple sclerosis: Contribution of
          inflammation, autoimmune mediated neuronal damage and therapeutic
          interventions.
          <cite>Autoimmun Rev.</cite>
          2017;16(9):925-936.doi:10.1016/j.autrev.2017.07.004
        </li>
        <li>
          Carotenuto A, Costabile T, Pontillo G, et al. Cognitive trajectories
          in multiple sclerosis: a long-term follow-up study.
          <cite>Neurol Sci. Published online</cite> 2021.
          doi:10.1007/s10072-021-05356-2
        </li>
        <li>
          Giovannoni G, Butzkueven H, Dhib-Jalbut S, et al. Brain health: time
          matters in multiple sclerosis.<cite> Mult Scler Relat Disord.</cite>
          2016;9:S5-S48. doi:10.1016/j.msard.2016.07.003
        </li>
        <li>
          Benedict RHB, Amato MP, DeLuca J, Geurts JJG. Cognitive impairment in
          multiple sclerosis: clinical management, MRI, and therapeutic
          avenues.<cite> Lancet Neurol.</cite> 2020;19(10):860-871.
          doi:10.1016/S1474-4422(20)30277-5
        </li>
        <li>
          Garlit D. The embarrassment of brain fog. MultipleSclerosis.net.
          Published 2020. Accessed May 5, 2022.
          https://multiplesclerosis.net/living-with-ms/embarrassment-brain-fog
        </li>
        <li>
          Boeschoten RE, Braamse AMJ, Beekman ATF, et al. Prevalence of
          depression and anxiety in Multiple Sclerosis: A systematic review and
          meta-analysis. <cite>J Neurol Sci.</cite> 2017;372:331-341.
          doi:10.1016/j.jns.2016.11.067
        </li>
        <li>
          Solaro C, Gamberini G, Masuccio FG. Depression in multiple sclerosis:
          epidemiology, aetiology, diagnosis and treatment.
          <cite>CNS Drugs.</cite> 2018;32(2):117-133.
          doi:10.1007/s40263-018-0489-5
        </li>
        <li>
          Manjaly ZM, Harrison NA, Critchley HD, et al. Pathophysiological and
          cognitive mechanisms of fatigue in multiple sclerosis.
          <cite>J Neurol Neurosurg Psychiatry.</cite> 2019;90(6):642-651.
          doi:10.1136/jnnp-2018-320050
        </li>
        <li>
          Rottoli M, La Gioia S, Frigeni B, Barcella V. Pathophysiology,
          assessment and management of multiple sclerosis fatigue: an update.
          <cite>Expert Rev Neurother.</cite> 2017;17(4):373-379.
          doi:10.1080/14737175.2017.1247695
        </li>
        <li>
          Multiple Sclerosis Society of Canada. MS Fatigue. Published 2015.
          Accessed May 5, 2022.
          https://mssociety.ca/library/document/rJfL1dpR3wsaAE
          vX284B5ITCnVQxy67S/original.pdf
        </li>
        <li>
          Solaro C, Trabucco E, Messmer Uccelli M. Pain and multiple sclerosis:
          pathophysiology and treatment topical collection on demyelinating
          disorders. <cite>Curr Neurol Neurosci Rep.</cite> 2013;13(1).
          doi:10.1007/s11910-012-0320-5
        </li>
        <li>
          Kratz AL, Whibley D, Alschuler KN, et al. Characterizing chronic pain
          phenotypes in multiple sclerosis: a nationwide survey study.
          <cite>Pain.</cite> 2021;162(5):1426-1433.
          doi:10.1097/j.pain.0000000000002136
        </li>
        <li>
          Urits I, Adamian L, Fiocchi J, et al. Advances in the understanding
          and management of chronic pain in multiple sclerosis: a comprehensive
          review. <cite>Curr Pain Headache Rep.</cite> 2019;23(8). <br />
          doi:10.1007/s11916-019-0800-2
        </li>
        <li>
          Scherder RJ, Kant N, Wolf ET, Pijnenburg BCM, Scherder EJA. Sensory
          function and chronic pain in multiple sclerosis.<cite>
            Pain Res Manag.</cite
          >
          2018;2018. doi:10.1155/2018/1924174
        </li>
        <li>
          Kale N. Optic neuritis as an early sign of multiple sclerosis.
          <cite>Eye Brain. </cite>2016;8:195-202. doi:10.2147/EB.S54131
        </li>
      </ol>
    </InnerContent>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader";

export default {
  name: "References",
  components: {
    ContentHeader,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/styles.scss";

#references {
  width: 100%;
  position: relative;
  background: $blue-dark;

  .inner-content {
    padding-bottom: 20px;
  }
}

ol {
  margin-left: -20px;
  column-count: 2;
  column-gap: 80px;

  @include breakpoint(sm) {
    column-count: 1;
  }

  li {
    margin-top: 10px;
    padding-left: 10px;
    font-size: rem(16px);
    color: $white;
    break-inside: avoid-column;
  }
}
</style>
